import OptionChainToolUseCase from "@domains/features/Search/useCases/OptionChainToolsUseCase";
import GeneralSearchUseCase from "@domains/features/Search/useCases/GenSearchUseCase";
import TrendingSearchUseCase from "@domains/features/Search/useCases/TrendingSearchUseCase";
import EquitySearchUseCase from "@domains/features/Search/useCases/EqSearchUseCase";
import FutureSearchUseCase from "@domains/features/Search/useCases/FuSearchUseCase";
import OptionSearchUseCase from "@domains/features/Search/useCases/OpSearchUseCase";
import IndicesSearchUseCase from "@domains/features/Search/useCases/IndicesSearchUseCase";
import MFSearchUseCase from "@domains/features/Search/useCases/MFSearchUseCase";
import NCDSearchUseCase from "@domains/features/Search/useCases/NCDSearchUseCase";
import ETFSSearchUseCase from "@domains/features/Search/useCases/ETFSSearchUseCase";
import FaqSearchUseCase from "@domains/features/Search/useCases/FaqSearchUseCase";
import PrimaryMarketSearchUseCase from "@domains/features/Search/useCases/PMSearchUseCase";
import CommFutSearchUseCase from "@domains/features/Search/useCases/ComFutSearchUseCase";
import CommOptSearchUseCase from "@domains/features/Search/useCases/ComOptSearchUseCase";
import SaveTrendingUseCase from "@domains/features/Search/useCases/saveTrendingUseCase";
import { SearchAssetTypeEnum } from "@frameworks/shared-library/components/Search/constant";
import StreamUseCase from "@domains/useCases/StreamUsecase";
import DeleteRecentUseCase from "@domains/features/Search/useCases/DeleteRecentUseCase";
import PutAllRecentListUseCase from "@domains/features/Search/useCases/PutAllRecentUseCase";
import CurFutSearchUseCase from "@domains/features/Search/useCases/CurFutSearchUseCase";
import CurOptSearchUseCase from "@domains/features/Search/useCases/CurOptSearchUseCase";
export default (function (repositories) {
    var _a;
    return {
        search: {
            optionChainTool: new OptionChainToolUseCase(repositories.search),
            genSearch: new GeneralSearchUseCase(repositories.search),
            faqSearch: new FaqSearchUseCase(repositories.search),
            trendingSearch: new TrendingSearchUseCase(repositories.search),
            assetSearch: (_a = {},
                _a[SearchAssetTypeEnum.Equity] = new EquitySearchUseCase(repositories.search),
                _a[SearchAssetTypeEnum.Future] = new FutureSearchUseCase(repositories.search),
                _a[SearchAssetTypeEnum.Option] = new OptionSearchUseCase(repositories.search),
                _a[SearchAssetTypeEnum.Indices] = new IndicesSearchUseCase(repositories.search),
                _a[SearchAssetTypeEnum.MF] = new MFSearchUseCase(repositories.search),
                _a[SearchAssetTypeEnum.NcdSecondary] = new NCDSearchUseCase(repositories.search),
                // [SearchAssetTypeEnum.SGB]: new SGBSearchUseCase(repositories.search),
                _a[SearchAssetTypeEnum.ETFs] = new ETFSSearchUseCase(repositories.search),
                // [SearchAssetTypeEnum.CORPFD]: new CorpFDSearchUseCase(
                //   repositories.search
                // ),
                _a[SearchAssetTypeEnum.CurFut] = new CurFutSearchUseCase(repositories.search),
                _a[SearchAssetTypeEnum.CurOpt] = new CurOptSearchUseCase(repositories.search),
                _a[SearchAssetTypeEnum.PrimaryMarket] = new PrimaryMarketSearchUseCase(repositories.search),
                _a[SearchAssetTypeEnum.ComFut] = new CommFutSearchUseCase(repositories.search),
                _a[SearchAssetTypeEnum.ComOpt] = new CommOptSearchUseCase(repositories.search),
                _a),
            saveTrendingSearch: new SaveTrendingUseCase(repositories.search),
            searchStreaming: new StreamUseCase(repositories.quoteStream),
            deleteRecent: new DeleteRecentUseCase(repositories.search),
            putAllRecent: new PutAllRecentListUseCase(repositories.search),
        },
    };
});
